import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { useHistory } from "react-router-dom";

import { NavigateToPath } from "../../../system";

const Footer = () => {
  const history = useHistory();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12 p-0">
            <div className="footer-social-links d-flex justify-content-center justify-content-lg-start mb-0 pb-0">
              <ul className="list-inline pb-0">
                <li>
                  <a
                    href="https://www.instagram.com/shutterb.co"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faInstagram} color="white" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@shutterb.co"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faTiktok} color="white" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/shutterb.co"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faFacebook} color="white" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 p-0">
            <div className="footer-links d-flex justify-content-center justify-content-lg-start">
              <ul className="list-unstyled d-flex flex-column flex-lg-row mr-0 mr-lg-auto">
                <li className="mb-2 mb-lg-0">
                  <a
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/pricing-calculator/`}
                  >
                    Quick quote
                  </a>
                </li>
                <li className="mb-2 mb-lg-0">
                  <a
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/affiliate/`}
                  >
                    Become a partner
                  </a>
                </li>
                <li className="mb-2 mb-lg-0">
                  <a
                    href="#"
                    onClick={() => {
                      NavigateToPath(history, "/be-a-shutterb");
                    }}
                  >
                    Become a shutterb
                  </a>
                </li>
                <li className="mb-0">
                  <a href="mailto:info@shutterb.co">Investors</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 p-0 d-block d-lg-flex align-items-center">
            <div className="footer-bottom">
              <p>© 2026 shutterb. All Rights Reserved.</p>
            </div>
            <div className="footer-bottom px-1">
              <a
                href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/privacy-policy/`}
                className="pr-2 text-underline policy-border"
              >
                Privacy Policy
              </a>
              <a
                href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/terms-and-conditions/`}
                className="pl-2 text-underline"
              >
                Terms and Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
